import { jsxs as l, jsx as C } from "react/jsx-runtime";
function e(r) {
  return /* @__PURE__ */ l("svg", { fill: "none", height: "1em", viewBox: "0 0 24 24", width: "1em", ...r, children: [
    /* @__PURE__ */ C(
      "path",
      {
        d: "M21.374 10.2812C17.6289 9.1645 16.8359 8.3715 15.7187 4.6254C15.624 4.3075 15.332 4.0898 14.9999 4.0898C14.6678 4.0898 14.3759 4.3076 14.2811 4.6254C13.1639 8.3715 12.3709 9.1645 8.62581 10.2812C8.30741 10.3759 8.08971 10.6684 8.08971 11C8.08971 11.3316 8.30751 11.624 8.62581 11.7188C12.3709 12.8355 13.1639 13.6285 14.2811 17.3746C14.3758 17.6925 14.6678 17.9102 14.9999 17.9102C15.332 17.9102 15.6239 17.6924 15.7187 17.3746C16.8359 13.6285 17.6289 12.8355 21.374 11.7188C21.6924 11.6241 21.9101 11.3316 21.9101 11C21.9101 10.6684 21.6923 10.376 21.374 10.2812Z",
        fill: "currentColor"
      }
    ),
    /* @__PURE__ */ C(
      "path",
      {
        d: "M8.68751 5.1406C6.81451 4.582 6.41801 4.1855 5.85941 2.3125C5.76371 1.9951 5.23641 1.9951 5.14061 2.3125C4.58201 4.1855 4.18551 4.582 2.31251 5.1406C2.15431 5.188 2.04491 5.334 2.04491 5.5C2.04491 5.666 2.15431 5.812 2.31251 5.8594C4.18551 6.418 4.58201 6.8145 5.14061 8.6875C5.18851 8.8462 5.33401 8.9551 5.50001 8.9551C5.66601 8.9551 5.81151 8.8462 5.85941 8.6875C6.41801 6.8145 6.81451 6.418 8.68751 5.8594C8.84571 5.812 8.95511 5.666 8.95511 5.5C8.95511 5.334 8.84571 5.188 8.68751 5.1406Z",
        fill: "currentColor"
      }
    ),
    /* @__PURE__ */ C(
      "path",
      {
        d: "M10.6875 18.1406C8.81451 17.582 8.41801 17.1855 7.85941 15.3125C7.76371 14.9951 7.23641 14.9951 7.14061 15.3125C6.58201 17.1855 6.18551 17.582 4.31251 18.1406C4.15431 18.188 4.04491 18.334 4.04491 18.5C4.04491 18.666 4.15431 18.812 4.31251 18.8594C6.18551 19.418 6.58201 19.8145 7.14061 21.6875C7.18851 21.8462 7.33401 21.9551 7.50001 21.9551C7.66601 21.9551 7.81151 21.8462 7.85941 21.6875C8.41801 19.8145 8.81451 19.418 10.6875 18.8594C10.8457 18.812 10.9551 18.666 10.9551 18.5C10.9551 18.334 10.8457 18.188 10.6875 18.1406Z",
        fill: "currentColor"
      }
    )
  ] });
}
export {
  e as default
};
